export default {
  title: 'Dossier patient',
  subtitle: 'Informations du dossier',
  close: 'Clore le dossier',
  creationDate: 'Créé le ',
  incomingData: {
    sessionData: 'Données de séance',
    biologyData: 'Données de biologie',
    dsstPayload: 'Test de substitution de symboles numériques',
    cardiacCoherenceBreathingExercisePayload: 'Cohérence cardiaque',
    softPranayamaBreathingExercisePayload: 'Pranayama doux',
    oneTwoBreathingExercisePayload: 'Respiration 1:2',
    twoOneBreathingExercisePayload: 'Respiration 2:1',
    boxBreathingExercisePayload: 'Box breathing',
    fourSevenEightBreathingExercisePayload: '4-7-8',
    eyeTrackingTestPayload: 'Eye tracking',
    cognitiveExercisePayload: 'Exercice cognitif',
    nBackTestPayload: 'Test N-Back',
    bessTestPayload: 'Test BESS',
    goNoGoTestPayload: 'Test Go/No-Go',
    srtPayload: 'Test SRT',
    stroopTestPayload: 'Test Stroop',
    trailMakingTestPayload: 'Test Trail Making',
    concussionFollowUpFormPayload: 'Suivi de commotion',
    symptomSelfAssessmentPayload: 'Auto-évaluation des symptômes',
    manualInput: 'Saisie manuelle',
    unknown: 'Inconnu',
    formResponse: 'Questionnaire',
    calculation: 'Calcul',
    biology: 'Biologie',
    iot: 'Objet connecté',
    unknownType: 'Type inconnu',
    dataReceivedInfo: '{type}, donnée reçue le {date}'
  },
  history: {
    entries: {
      rendezVous: {
        create: {
          title: 'Créer un rendez-vous'
        },
        update: {
          title: 'Modifier un rendez-vous'
        },
        title: 'Rendez-vous',
        subtitle: 'Permet de planifier un rendez-vous',
        info: 'Informations sur ce rendez-vous',
        new: 'Créer un nouveau rendez-vous',
        form: {
          shareWithMedicalTeam: 'Partager à l\'équipe médicale',
          date: 'Date',
          from: 'de',
          to: 'à',
          addReminder: 'Ajouter un rappel',
          delay: 'Délai',
          createSuccess: 'Le rendez-vous a été créé avec succès',
          updateSuccess: 'Le rendez-vous a été mis à jour',
          createFailure: 'Impossible de créer le rendez-vous',
          updateFailure: 'Impossible de mettre à jour le rendez-vous'
        },
        details: {
          createdBy: 'Crée par',
          sharedWithMedicalTeam: 'Partagé avec l\'équipe médicale',
          description: 'Description',
          noDescription: 'Aucune description',
          reminder: 'Rappel',
          before: 'avant',
          noReminder: 'Aucun rappel',
          note: 'Note de rappel',
          noNote: 'Aucune note de rappel',
          icsDownload: 'Télécharger au format ICS',
          confirmDeletion: 'Vous êtes sur le point de supprimer ce rendez-vous. Continuer ?',
          deletionSuccess: 'Le rendez-vous a été supprimé avec succès.',
          deletionFailure: 'Impossible de supprimer le rendez-vous'
        }
      },
      reminder: {
        create: {
          title: 'Créer un rappel'
        },
        update: {
          title: 'Modifier un rappel'
        },
        title: 'Rappel',
        subtitle: 'Permet de planifier un rappel',
        new: 'Créer un nouveau rappel',
        note: 'Note de rappel',
        offset: 'Délai',
        form: {
          date: 'Date de rappel',
          time: 'Heure de rappel',
          shareWithMedicalTeam: 'Partager à l\'équipe médicale',
          success: 'Le rappel a été créé avec succès',
          failure: 'Impossible de créer le rappel'
        }
      }
    }
  },
  content: {
    item: {
      restore: 'Restaurer le contenu pour le dossier',
      restoreError: 'Une erreur est survenue durant la restauration du contenu'
    }
  },
  about: {
    createdOn: 'Votre dossier patient a été créé le ',
    inService: 'dans le service {serviceName} de l\'établissement {establishmentName}'
  },
  monitoring: {
    loading: 'Chargement de votre suivi en cours',
    history: {
      title: 'Mon historique',
      noData: 'Pas de données',
      actor: {
        you: 'Vous avez',
        him: 'a '
      },
      consulted: 'consulté le ',
      responded: 'répondu le '
    },
    data: 'Mes dernières données',
    content: 'Mon contenu thérapeutique',
    noContent: {
      firstLine: 'Aucun contenu disponible pour le moment',
      secondLine: 'Votre éducation thérapeutique sera accessible dès qu\'elle sera ajoutée par un professionnel de santé'
    },
    noData: {
      firstLine: 'Aucune donnée disponible pour le moment',
      secondLine: 'Vos graphiques de mesure, votre éducation thérapeutique et votre historique seront disponibles dès que des mesures seront ajoutées',
      inGraphs: 'Aucune donnée pour cette période'
    }
  },
  payloads: {
    question: 'Question',
    answer: 'Réponse',
    alertStatus: 'Statut d\'alerte',
    showQuestionsLabel: 'Afficher le libellé des questions',
    receivedImage: 'Image reçue : ',
    loadingFailure: 'Les données n\'ont pas pu être chargées',
    alert: 'Alerte',
    closed: 'Clôturée',
    pending: 'En attente',
    comment: 'Commentaire',
    alertConditions: {
      show: 'Afficher les conditions d\'alerte',
      hide: 'Masquer les conditions d\'alerte'
    },
    newMeasureCondition: {
      display: 'Afficher la condition de nouvelle mesure',
      hide: 'Masquer la condition de nouvelle mesure'
    },
    formCondition: 'Condition de questionnaire ayant généré cette mesure : ',
    condition: 'Condition ayant généré l\'alerte : ',
    dialysisSession: {
      from: 'Du',
      to : 'au',
      session : 'Séance',
      sessionOf: 'Séance du',
      duration: 'Durée :',
      machineName : 'Nom machine :',
      machineIdentifier : 'Identifiant machine :',
      location : 'Lieu :',
      site : 'Site :',
      beforeSection: 'Avant la séance',
      afterSection: 'Après la séance',
      during: 'Pendant la séance',
      otherData: 'Autres données',
      indicator: 'Indicateur',
      value: 'Valeur'
    }
  },
  graphs: {
    lastMeasures: 'Récupération de vos dernières mesures',
    noData: 'Aucune donnée disponible',
    error: {
      load: 'Impossible de récupérer les mesures du graphique {chart}',
      graphSettings: 'Impossible de charger les paramètres des graphiques'
    },
    in: 'en',
    referenceValue: 'Valeur de référence',
    minimum: 'Minimum{markLineNameSuffix}',
    maximum: 'Maximum{markLineNameSuffix}',
    median: 'Médiane{markLineNameSuffix}',
    average: 'Moyenne{markLineNameSuffix}'
  },
  contextSelector: {
    service: 'Service :',
    createdOn: 'Créé le {date}',
    inService: 'dans le service',
    closed: 'Fermé'
  },
  closedDialog: {
    title: 'Dossier patient clôturé',
    message: 'Ce dossier patient a été clôturé durant votre navigation.'
  }
}
